import {Component, Input} from '@angular/core';
/**
 * A component that renders an SVG icon for "Lock-Open-Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-lock-open-outline',
    templateUrl: './icon-lock-open-outline.component.html',
    styleUrls: ['./icon-lock-open-outline.component.scss'],
    standalone: false
})
export class IconLockOpenOutlineComponent  {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
